"use client";

import { useState } from "react";
import { Check, Copy } from "lucide-react";

/** The server address, with a button that copies it for Multiplayer → Add Server. */
export default function CopyAddress({ address }: { address: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard blocked (insecure context, permissions): the address is still on screen.
    }
  }

  return (
    <div className="flex items-center gap-2 rounded-lg border border-white/10 bg-black/20 py-1.5 pl-3 pr-1.5">
      <code className="font-mono text-sm text-foreground/90">{address}</code>
      <button
        type="button"
        onClick={copy}
        aria-label={copied ? "Copied" : `Copy ${address}`}
        className="ml-auto flex h-7 w-7 items-center justify-center rounded-md text-foreground/60 transition hover:bg-white/10 hover:text-foreground"
      >
        {copied ? <Check className="h-4 w-4 text-emerald-400" /> : <Copy className="h-4 w-4" />}
      </button>
    </div>
  );
}
